import * as apiSelectors from './api/selectors';
import * as appSelectors from './application/selectors';
import * as authSelectors from './authentication/selectors';
import * as ffSelectors from './featureFlags/selectors';
import * as formSelectors from './form/selectors';
import * as saveSelectors from './save/selectors';
import * as sectionSelectors from './section/selectors';

/**
 * RootSelectors contains the selectors for all redux modules.
 *
 * Warning: Be careful about referencing this within `@redux/modules`, as there
 * is a possibility for circular dependencies.
 */
export const rootSelectors = {
  api: apiSelectors,
  application: appSelectors,
  authentication: authSelectors,
  featureFlags: ffSelectors,
  form: formSelectors,
  save: saveSelectors,
  section: sectionSelectors,
};
